import { render } from "./Forage.vue?vue&type=template&id=70995668&scoped=true"
import script from "./Forage.vue?vue&type=script&lang=js"
export * from "./Forage.vue?vue&type=script&lang=js"

import "./Forage.vue?vue&type=style&index=0&id=70995668&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70995668"]])

export default __exports__